import React from 'react';
import { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export function SkillGauge(){



    const sgauges = [
      { sgid: 1, name: "Photoshop", percent: '90%' },
      { sgid: 2, name: "Illustrator", percent: '75%' },
      { sgid: 3, name: "InDesign", percent: '65%' },
      { sgid: 4, name: "XD", percent: '50%' },
      { sgid: 5, name: "Dreamweaver", percent: '75%' },
      { sgid: 6, name: "Visual Studio", percent: '40%' }, 
      { sgid: 7, name: "Premiere Pro", percent: '85%' },
      { sgid: 8, name: "After Effects", percent: '60%' },
      { sgid: 9, name: "Animate", percent: '70%' },
      { sgid: 10, name: "Blender", percent: '60%' },
      { sgid: 11, name: "Dimension", percent: '45%' },
      { sgid: 12, name: "Soundbooth", percent: '60%' },
    ];

  
    const skill_gauge_ref = useRef(); 
// =================== //
// JS/GSAP ANIMATION 
// ===================//
useGSAP(() => {


   
    let thumb = document.querySelectorAll('.skill_gauge'); 
   
   
   ScrollTrigger.batch(thumb, {
    start: 'center bottom',
    once:true,  // <<< ==== ======================================= This makes it pin only once !!!
    onEnter: batch => {
      batch.forEach((section, index) => {
 
       let tl_sg = gsap.timeline({});
       let gauge_needle = section.querySelectorAll('.skill_gauge_needle');
       let gauge_bar = section.querySelectorAll('.skill_gauge_bar_bg path');


       // NEW FEATURE - get data from div.
       let gauge_percent = section.querySelectorAll('.new-skillgauge').innerHTML;
       //let gp_data = gauge_percent.innerHTML = 50000000000;
       console.log(gauge_percent);

       

        // TEXT PERCENTAGE ANIMATION
        let txtPercent = section.querySelector(".skill_gauge_txt"); // get value
        let tPercent = txtPercent.textContent;
        let tPercentClean = tPercent.replace('%', '');// clean out our percentage symbol for the gauge animations
        let txtP =  tPercentClean / 100 * 180; // do the mastch for our half circle object
        //console.log(tPercentClean);


    tl_sg.from(txtPercent, {
      textContent: 0 + '%',
      duration: 1.5,
      ease: "power1.in",
      snap: { textContent: 1 },
       stagger: 1,
       dealy:2,
    })

   .to(gauge_needle, {
       duration:1,
       rotation: txtP ,  
       stagger: 0.2,
       transformOrigin:"113px 20px", 
      delay: 0,
     ease: "power2.out",
        }, 0.4 )
      
    .to(gauge_bar, {
      stagger: 0.2,
      duration:1, 
      rotation: txtP  ,
      transformOrigin:"150px 150px", 
      delay: -0.65,
      ease: "power2.out",
        }, 1 );

      })
    },
    once: true
  });


  }, {scope: skill_gauge_ref });
// End of useGSAP


// PRINT SKILL GAUGE
return (
 <div className="skill_gauge_container" ref={skill_gauge_ref}> 
{sgauges.map((gauge) => (
          
        <div className="skill_gauge" key={gauge.id}>
          <svg className="skill_gauge_cont" version="1.1" x="0px" y="0px" viewBox="0 0 300 172">
            <text x="50%" y="70%" className="skill_gauge_txt" alignment-baseline="middle" text-anchor="middle">{gauge.percent}</text>
            <defs>
              <clipPath id={"clipPath"+(gauge.sgid)}>
              <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" />
              </clipPath>
              </defs>
              <g className="skill_gauge_indicator">
                       <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" /></g>

                    <g className="skill_gauge_bar_bg" style={{"clipPath":"url(#clipPath"+(gauge.sgid)+")" }}> 
                      <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" /></g>

                    <g className="skill_gauge_needle"><path d="M133.1,139.4l-96.4,10.7l96.4,10.4c3.5,5.7,9.8,9.5,17,9.5c11,0,20-9,19.9-20.1c0-11-9-20-20.1-19.9C142.9,129.9,136.6,133.7,133.1,139.4z"/></g>
             </svg><div className="gauge-title">{gauge.name}</div>

     </div>
   ))}


</div>
);
  




	

 }
        